import { z } from 'zod'

export const generatorFormSchema = z.object({
  shopLogoFileTmp: z.string().min(1, 'Logo producenta jest wymagane'),
  productImageFileTmp: z.string().min(1, 'Zdjęcie produktu jest wymagane'),
  templateFileTmp: z.string(),
  mainColors: z.string().min(1, 'Kolory są wymagane'),
  creationDescription: z.string().min(1, 'Opis kreacji jest wymagany'),
  productName: z.string().optional().or(z.literal('')),
  adSlogan: z.string().min(1, 'Slogan reklamy jest wymagany'),
  price: z.string().min(1, 'Cena jest wymagana'),
  priceDescription: z.string().optional().or(z.literal('')),
  priceLast30Days: z.string().min(1, 'Cena z ostatnich 30 dni jest wymagana'),
  quality: z.enum(['ORIGINAL', 'UPSCALE_2X', 'UPSCALE_4X']),
  resolution: z.array(z.enum(['1536x1024', '1024x1536', '1024x1024'])),
  areProductInscriptionsCrucial: z.boolean(),
  preferredFontHeadHtml: z.string().min(1, 'Czcionka jest wymagana')
})

export type FormSchema = z.infer<typeof generatorFormSchema>
